import React from "react";
import styles from "./loading.module.scss";

const Loading2 = ()=> <div className={styles.loading}></div>;

export default Loading2;